import { IGroup } from "@main/users/group";
import { MultiUserFormPermission } from "./multi-user-form-permissions.dto";
import { ISystemRole } from "@main/system-roles/system-role";

export enum StageTargetType {
    InnerGroups = 0,
    ExternalUsers,
    Self,
    Patient
}
const StageTargetTypeMap: { [key: number]: string } = {};
StageTargetTypeMap[StageTargetType.InnerGroups] = "User Types";
StageTargetTypeMap[StageTargetType.ExternalUsers] = "External Users";
StageTargetTypeMap[StageTargetType.Self] = "Self";
StageTargetTypeMap[StageTargetType.Patient] = "Patient";
export const getStageTargetType = (type?: StageTargetType) => (type in StageTargetTypeMap ? StageTargetTypeMap[type] : "");

export class MUFUserTargets {
    name: string;
    id: string;
    userTypeId: number;
    organizationId: number[];
}

export class MUFUserTypeTargets {
    name: string;
    userTypeId: number;
}

export class MultiUserFormStage {
    id: string;
    id_original: number;
    name: string;
    userTypes: ISystemRole[];
    userTypeIds: number[];
    tabComponentKey: string;
    innerTabKey: string;
    stageTargetType: StageTargetType;
    reviewerStage: boolean;
    sequenceStepIndex: number;
    multiUserFormStagePermissions: MultiUserFormPermission[];
}

export class MultiUserFormStageUpdate {
    id: number;
    name: string;
    userTypeIds: number[];
    stageTargetType: number;
    sequenceStepIndex: number;
    reviewerStage: boolean;
}

export enum MultiUserFormStagePermissionAction {
    Hide = 0,
    ReadOnly,
    Edit
  }